import React from "react"

import FieldProto from "../proto/field-proto"
import FieldView from "./view"
import {FieldAccess, FieldViewSize} from "../const";

export type FieldInlineEditableProps = {
    className?      : string
    inputClassName? : string

    field           : FieldProto
    model           : any

    size?       : FieldViewSize

    options?        : any
    configOptions?  : any
    viewType?       : string

    disabled?       : boolean
    onChange?       : func
}

export default function FieldInlineEditable(props:FieldInlineEditableProps):any {

    // console.log("FieldInlineEditable", props.field.fieldId)
    // console.log(props.field.renderComponents.inlineEditable)

    const autosave = (value:any)=>{
        props.model[props.field.fieldId] = value
        props.model.save()
    }

    let disabled    = false

    if (!_.isNil(props.disabled)) { // check if disabled property is overridden
        disabled = props.disabled
    } else if (props.field.isDisabled) {
        disabled = true
    }

    const access = props.field.access(props.model)

    if (disabled || access === FieldAccess.READ) {
        return <FieldView  className    = {props.className}
                           field        = {props.field}
                           model        = {props.model}/>
    } else {
        switch (props.field.access(props.model)) {
            case false      :
                return false
            /*case 'read'     :
                // console.log("field ", props.field.fieldId, "is read only -> FieldView")
                return <FieldView  className    = {props.className}
                                   field        = {props.field}
                                   model        = {props.model}/>*/
            case FieldAccess.WRITE:
                return (
                    <props.field.renderComponents.inlineEditable field          = {props.field}
                                                                 model          = {props.model}
                                                                 size           = {props.size}
                                                                 onChange       = {props.onChange ? props.onChange : autosave}
                                                                 className      = {props.className}
                                                                 inputClassName = {props.inputClassName}
                                                                 options        = {props.options}
                                                                 configOptions  = {props.configOptions}/>
                )
        }
    }
}
